module.exports = __webpack_public_path__ + "media/images/SettingsCog-fd09052e818342574cc719f0b72f0be8.png";